import {
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';

import { createSemanticModelResource } from './createSemanticModelResource.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const jsmSummarySemanticModelResource: RouteResource<any> = createSemanticModelResource({
	hostingProduct: 'jira',
	location: 'jsm-summary',
	products: ['jira'],
	subProducts: ['jsm'],
});

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const useJsmSummarySemanticModel = (): UseResourceHookResponse<any> =>
	useResource(jsmSummarySemanticModelResource);
